<template>
    <common-modal width="medium" @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <div class="auth-sign-up-confirm-practice--container">
            <common-content-spacer height="large">
                <div class="auth-sign-up-confirm-practice__svg-container">
                    <div class="auth-sign-up-confirm-practice__svg">
                        <svg>
                            <use xlink:href="#picture-logo" />
                        </svg>
                    </div>
                </div>
                <div class="auth-sign-up-confirm-practice">
                    <p class="header">
                        {{
                            $tc(
                                'pages.auth.signup.steps.register.confirm_practice_modal.practices_number',
                                suggestedPractices.length,
                            )
                        }}
                        {{ data.selectedPracticeName ? data.selectedPracticeName : data.practiceName }}
                    </p>
                </div>
                <div class="auth-sign-up-confirm-practice">
                    <p class="practice-name">
                        <b>{{ selectedPractice.name }}</b>
                        | {{ selectedPractice.city }}, {{ selectedPractice.state }}
                    </p>
                    <p class="practice-name">
                        {{
                            $t('pages.auth.signup.steps.register.confirm_practice_modal.created_by', {
                                name: selectedPractice.createdByName,
                            })
                        }}
                    </p>
                </div>
                <div class="auth-sign-up-confirm-practice">
                    <p class="sub-header">
                        {{ $t('pages.auth.signup.steps.register.confirm_practice_modal.join_text') }}
                    </p>
                    <p class="sub-header">
                        {{
                            $t(
                                userCanCreatePractice
                                    ? 'pages.auth.signup.steps.register.confirm_practice_modal.join_text_physician'
                                    : 'pages.auth.signup.steps.register.confirm_practice_modal.join_text_non_physician',
                            )
                        }}
                    </p>
                </div>
                <div class="auth-sign-up-confirm-practice">
                    <footer>
                        <common-buttons>
                            <common-button
                                v-show="userCanCreatePractice"
                                class="auth-sign-up-confirm-practice__button"
                                :label="$t('pages.auth.signup.steps.register.confirm_practice_modal.register_new')"
                                type="secondary"
                                size="large"
                                @click="
                                    emitEvent({ name: 'register-new-practice', payload: suggestedPractices[practiceNumber - 1] })
                                "
                            ></common-button>
                            <common-button
                                class="auth-sign-up-confirm-practice__button"
                                :label="$t('pages.auth.signup.steps.register.confirm_practice_modal.join_existing')"
                                type="primary"
                                size="large"
                                @click="
                                    emitEvent({ name: 'join-existing-practice', payload: suggestedPractices[practiceNumber - 1] })
                                "
                            ></common-button>
                        </common-buttons>
                    </footer>
                </div>
                <div class="auth-sign-up-confirm-practice">
                    <common-pagination
                        :numberOfItems="suggestedPractices.length"
                        @page-changed="showAnotherPractice($event)"
                    ></common-pagination>
                </div>
            </common-content-spacer>
        </div>
    </common-modal>
</template>

<script>
    export default {
        props: {
            userCanCreatePractice: { type: Boolean, required: true },
            suggestedPractices: { type: Array, required: true },
            data: { type: Object, required: true },
        },

        data() {
            return {
                practiceNumber: 1,
            }
        },

        computed: {
            selectedPractice() {
                return this.suggestedPractices[this.practiceNumber - 1]
            },
        },

        methods: {
            showAnotherPractice(pageNumber) {
                this.practiceNumber = pageNumber
            },
        },
    }
</script>
